// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__212kI","content":"LayoutSettings_content__1Qurf"};